import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase"; // Firebase Auth instance

// PrivateRoute component to protect routes
const PrivateRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth); // Check if user is authenticated

  if (loading) {
    // Show loading state while authentication is being checked
    return <div>Loading...</div>;
  }

  if (!user) {
    // Redirect to login if the user is not authenticated
    return <Navigate to="/login" />;
  }

  // If user is authenticated, allow access to the protected route
  return children;
};

export default PrivateRoute;

